import React, { Component } from 'react'
import { connect } from 'react-redux'
import { splitReceiptModalAddLineRight } from '../../actions/modalActions.js'
import Slip from 'slipjs'
import * as resource from '../../../constants/Resources'
import { getTranslation } from '../../../actions/dataActions'
import PropTypes from 'prop-types'

class SplitReceiptModalLeftReceipt extends Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
    }

    handleTouchTap(lineid, quantity) {
        if(quantity!==0)
            this.props.callback(lineid);
    }

    componentDidMount() {
        const list = document.querySelector('#left_receipt_ul');
        new Slip(list);
        list.addEventListener('slip:swipe', this.onSwipe.bind(this));

        //Disable reorder
        list.addEventListener('slip:beforereorder', function (e) {
            e.preventDefault();
        });
    }


    onSwipe() {
        const lineid = arguments[0].target.id;
        this.props.splitReceiptModalAddLineRight(lineid, true);
    }

    render() {
        let totalprice = 0;

        return (
            <div className="receiptLeft_wrapper">
                <div className="header">
                    Bon #{this.props.receiptnumber}
                </div>
                <div className="receipt">
                    <div className="scrollable no_user_select" id="left_receipt_ul">
                        {
                            this.props.receiptlines.map(line => {
                                totalprice += line.price;
                                if (!line.simpleSeparator)
                                {
                                    return (
                                        <div className="receiptLine no_user_select" key={line.id} id={line.id} onClick={() => this.handleTouchTap(line.id, line.quantity)}>
                                            <div className="amount">
                                                {line.quantity}x
                                            </div>
                                            <div className="description">
                                                {line.text}
                                            </div>
                                            <div className="price">
                                                {line.price.toFixed(2).replace('.', ',')}
                                            </div>
                                        </div>
                                    )
                                }
                                else
                                {
                                    return (
                                        <div className="simpleSeparator no_user_select">
 
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                </div>
                <div className="receiptFooter">
                    <div className="footer_top">
                        <div className="text_total">
                            {this.props.getTranslation(resource.SUB_TOTAL)}
                        </div>
                        <div className="totalprice_wrapper">
                            <div className="top">
                                {totalprice.toFixed(2).replace('.', ',')}
                            </div>
                        </div>
                    </div>
                    <div className="footer_bottom">
                    </div>
                </div>
            </div>
        )
    }

}

SplitReceiptModalLeftReceipt.propTypes = {
    receiptModal: PropTypes.object.isRequired,
    callback: PropTypes.func,
    inputquantity: PropTypes.string,
    inputquantitynegative: PropTypes.bool,
    receiptnumber: PropTypes.number,
}

function mapStateToProps(state) {
    return {
        receiptModal: state.modalState.splitReceiptModal,
        inputquantity: state.receiptState.input.inputquantity,
        inputquantitynegative: state.receiptState.input.inputquantitynegative,
        receiptnumber: state.receiptState.receipt.receiptnumber
    }
}

export default connect(mapStateToProps, { splitReceiptModalAddLineRight, getTranslation })(SplitReceiptModalLeftReceipt)


// WEBPACK FOOTER //
// src/modal/components/SplitReceiptModal/SplitReceiptModalLeftReceipt.jsx